import { render, staticRenderFns } from "./panda-table.vue?vue&type=template&id=4f98aea3&scoped=true"
import script from "./panda-table.vue?vue&type=script&lang=ts"
export * from "./panda-table.vue?vue&type=script&lang=ts"
import style0 from "./panda-table.vue?vue&type=style&index=0&id=4f98aea3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f98aea3",
  null
  
)

export default component.exports